import { Input, Select, Switch } from "@clintonelec/react-storybook";
import { eapolOptions, eapTypeOptions } from "Data/Objects/NetworkSecurity";
import type { NetworkSecurityState, SecurityCertificate } from "Interfaces";
import { memo } from "react";
import CertificateField from "Components/ConfigLayout/Network/SecuritySettings/CertificateField";

type IeeeTabProps = {
	securitySettings: NetworkSecurityState;
	handleIeeeEnabledChange: (checked: boolean) => void;
	handleEapTypeSelect: (value: string | null) => void;
	handleEapolVersionSelect: (value: string | null) => void;
	handleIeeeIdUpdate: (value: string) => void;
	handleIeeePasswordUpdate: (value: string) => void;
	handleCertificateUpdate: (certificate: SecurityCertificate) => void;
	handleIeeeClientKeyPasswordUpdate: (value: string) => void;
};

function IeeeTab(props: IeeeTabProps) {
	const {
		securitySettings, handleIeeeEnabledChange, handleEapTypeSelect, handleEapolVersionSelect, handleIeeeIdUpdate,
		handleIeeePasswordUpdate, handleCertificateUpdate: updateCertificate, handleIeeeClientKeyPasswordUpdate
	} = props;

	const certificateFields = securitySettings.certificates.map((cert) => (
		<CertificateField
			key={ cert.type }
			ieeeEnabled={ securitySettings.ieeeOptions.enabled }
			certificate={ cert }
			handleCertUpdate={ updateCertificate }
		/>
	));

	return (
		<div>
			<h4>802.1x Setup</h4>
			<div className="form-row switch">
				<span>IEEE 802.1x</span>
				<Switch
					checked={ securitySettings.ieeeOptions.enabled }
					formName="ieeeEnabled"
					onChange={ handleIeeeEnabledChange }
				/>
			</div>
			<div className="form-row">
				<span>EAP Type</span>
				<Select
					allowClear={ false }
					className="form-select"
					disabled={ !securitySettings.ieeeOptions.enabled }
					name="eapType"
					onSelect={ handleEapTypeSelect }
					options={ eapTypeOptions }
					value={ securitySettings.ieeeOptions.eapType }
				/>
			</div>
			<div className="form-row">
				<span>EAPOL Version</span>
				<Select
					allowClear={ false }
					className="form-select"
					disabled={ !securitySettings.ieeeOptions.enabled }
					name="eapolVersion"
					onSelect={ handleEapolVersionSelect }
					options={ eapolOptions }
					value={ securitySettings.ieeeOptions.eapolVersion }
				/>
			</div>
			<div className="form-row">
				<span>ID</span>
				<Input
					autoComplete="new-password"
					disabled={ !securitySettings.ieeeOptions.enabled }
					name="ieeeId"
					onUpdate={ handleIeeeIdUpdate }
					value={ securitySettings.ieeeOptions.id }
					wrapClassName="form-input security-wrapper"
				/>
			</div>
			<div className="form-row">
				<span>Password</span>
				<Input
					autoComplete="new-password"
					disabled={ !securitySettings.ieeeOptions.enabled }
					name="ieeeId"
					onUpdate={ handleIeeePasswordUpdate }
					password
					value={ securitySettings.ieeeOptions.password }
					wrapClassName="form-input security-wrapper"
				/>
			</div>
			<h4>Certificate Setting</h4>
			{ certificateFields }
			<div className="form-row">
				<span>Client Key Password</span>
				<Input
					autoComplete="new-password"
					disabled={ !securitySettings.ieeeOptions.enabled }
					onUpdate={ handleIeeeClientKeyPasswordUpdate }
					password
					value={ securitySettings.ieeeOptions.clientKeyPassword }
					wrapClassName="form-input security-wrapper"
				/>
			</div>
		</div>
	);
}

export default memo(IeeeTab);
